import { Grid } from "@mui/material";
import React, { useState } from "react";
import gallery1 from "../../assets/banners/gallery1.jpg";
import gallery2 from "../../assets/banners/gallery2.jpg";
import gallery3 from "../../assets/banners/gallery3.jpg";
import gallery4 from "../../assets/banners/gallery4.jpg";
import gallery5 from "../../assets/banners/gallery5.jpg";
import gallery6 from "../../assets/banners/gallery6.jpg";
import gallery7 from "../../assets/banners/gallery7.jpg";
import gallery8 from "../../assets/banners/gallery8.jpg";
import gallery9 from "../../assets/banners/gallery9.jpg";

import "./css/gallery.css";
import "./css/responsive_gallery.css";
import { useSelector } from "react-redux";
import { gallery_utils } from "../utils/GalleryUtils";
import Lightbox from "yet-another-react-lightbox";
import LightboxComponent from "../lightbox/LightboxComponent";
import GalleryReusableHook from "./hooks/GalleryReusableHook";

const GalleryReusable = (props) => {
  const { ...param } = GalleryReusableHook();
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const lightbox_status = useSelector(
    (state) => state.GlobalReducer.lightbox_status
  );
  return (
    <>
      <Grid
        container
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
        rowSpacing={1}
        justifyContent="center"
        className="gallery-main-container"
      >
        <LightboxComponent open={lightbox_status} close={param.closeLightbox} />

        <Grid item xs={12} sm={12} md={12} lg={12} className="gallery_left">
          <Grid
            container
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
            rowSpacing={1}
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Grid
                container
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
                rowSpacing={1}
                justifyContent="center"
              >
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Grid
                    container
                    columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                    columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
                    rowSpacing={1}
                    justifyContent="center"
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="gallery_img_container"
                    >
                      <div className="gallery-img-wrapper">
                        <img
                          src={gallery_utils[0].img}
                          alt="gallery_image"
                          className="gallery_image"
                          onClick={() => {
                            param.openLightbox(true);
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="gallery_img_container"
                    >
                      <div className="gallery-img-wrapper">
                        <img
                          src={gallery_utils[1].img}
                          alt="gallery_image"
                          className="gallery_image"
                          onClick={() => {
                            param.openLightbox(true);
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <img
                    src={gallery_utils[2].img}
                    alt="gallery_image"
                    className="gallery_image"
                    onClick={() => {
                      param.openLightbox(true);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div className="gallery-img-wrapper">
                    <img
                      src={gallery_utils[3].img}
                      alt="gallery_image"
                      className="gallery_image"
                      onClick={() => {
                        param.openLightbox(true);
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div className="gallery-img-wrapper">
                    <img
                      src={gallery_utils[4].img}
                      alt="gallery_image"
                      className="gallery_image"
                      onClick={() => {
                        param.openLightbox(true);
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Grid
                container
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
                rowSpacing={1}
                justifyContent="center"
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  className="gallery_img_container"
                >
                  <div className="gallery-img-wrapper">
                    <img
                      src={gallery_utils[5].img}
                      alt="gallery_image"
                      className="gallery_image"
                      onClick={() => {
                        param.openLightbox(true);
                      }}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  className="gallery_img_container"
                >
                  <div className="gallery-img-wrapper">
                    <img
                      src={gallery_utils[6].img}
                      alt="gallery_image"
                      className="gallery_image"
                      onClick={() => {
                        param.openLightbox(true);
                      }}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  className="gallery_img_container"
                >
                  <div className="gallery-img-wrapper">
                    <img
                      src={gallery_utils[7].img}
                      alt="gallery_image"
                      className="gallery_image"
                      onClick={() => {
                        param.openLightbox(true);
                      }}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  className="gallery_img_container"
                >
                  <div className="gallery-img-wrapper">
                    <img
                      src={gallery_utils[8].img}
                      alt="gallery_image"
                      className="gallery_image"
                      onClick={() => {
                        param.openLightbox(true);
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default GalleryReusable;
